import React from 'react';
import { Container, Paper, Typography, Button, Box } from '@mui/material';
import { BlockOutlined } from '@mui/icons-material';
import { useAuth } from '@vortx/shared-ui';

export default function NoAccess({ appName = 'this application' }) {
    const { logout, userProfile } = useAuth();

    return (
        <Container maxWidth="sm" sx={{ mt: 8 }}>
            <Paper sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <BlockOutlined sx={{ fontSize: 64, color: 'error.main' }} />

                <Typography variant="h4" align="center">
                    No Access to {appName}
                </Typography>

                <Typography variant="body1" align="center" color="text.secondary">
                    Your account ({userProfile?.email}) does not have access to {appName}.
                </Typography>

                <Typography variant="body2" align="center" color="text.secondary">
                    Please contact your company administrator to request access.
                </Typography>

                <Box sx={{ mt: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={logout}
                    >
                        Sign Out
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
}
